import { inject } from '@angular/core';
import {
  CanActivateFn,
  MaybeAsync,
  GuardResult,
  Router
} from '@angular/router';
import { OnboardingService } from '@infra-adapters/services/onboarding.service';

export const OnboardingGuard: CanActivateFn = (
  route,
  state
): MaybeAsync<GuardResult> => {
  const onboardingService = inject(OnboardingService);
  const router = inject(Router);
  if (!onboardingService.isOnboardingCompleted()) {
    return true;
  } else {
      return router.createUrlTree(['/login']);
  }
};
